import { render } from "./kalio-job-offer-show.vue?vue&type=template&id=448d149a"
import script from "./kalio-job-offer-show.vue?vue&type=script&lang=js"
export * from "./kalio-job-offer-show.vue?vue&type=script&lang=js"

import "./kalio-job-offer-show.vue?vue&type=style&index=0&id=448d149a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__